import React, { useState, useEffect } from "react";
import ZDrawer from "@molecules/ZDrawer";
import { ILogEmailBodyDrawerProps } from "./interface";
import { getLogEmailBody } from "../../../../../services/SalesActivity";
import ZSpin from "@molecules/ZSpin";
import { LogEmailBodyRespone } from "@/Contracts/Others/SalesActivity";
import ZEmailThread from "@organisms/ZEmailThread";

const ZLogEmailBodyDrawer: React.FC<ILogEmailBodyDrawerProps> = ({
	subject,
	visible,
	currentActiveSalesActivityId,
	onClose
}) => {
	const [logEmailBodyResponse, setLogEmailBodyResponse] =
		useState<LogEmailBodyRespone | null>(null);
	const [loading, setLoading] = useState(false);

	const getEmailBody = async () => {
		try {
			setLoading(true);
			setLogEmailBodyResponse(
				await getLogEmailBody(currentActiveSalesActivityId)
			);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (visible) getEmailBody();
	}, [visible]);

	return (
		<ZDrawer
			title={subject}
			visible={visible}
			onClose={onClose}
			removeDefaultPadding
			shouldTitleTruncate={false}
		>
			<ZSpin spinning={loading}>
				{logEmailBodyResponse && (
					<ZEmailThread
						threads={[
							{
								id: currentActiveSalesActivityId,
								from: logEmailBodyResponse.email_person_details
									?.from,
								to:
									logEmailBodyResponse.email_person_details
										?.to ?? [],
								date: logEmailBodyResponse.date,
								body:
									logEmailBodyResponse.email_log_body_html ??
									"",
								subject: subject,
								cc:
									logEmailBodyResponse.email_person_details
										?.cc ?? [],
								bcc:
									logEmailBodyResponse.email_person_details
										?.bcc ?? []
							}
						]}
					/>
				)}
			</ZSpin>
		</ZDrawer>
	);
};

export default ZLogEmailBodyDrawer;
